module.exports = __webpack_public_path__ + "img/admision2027.a6e3b805.jpg";